import React from 'react';
import { SORT_NAME, SORT_DENSITY, coverageOf, formatCount } from '../../fields.utils';
import {
  Rail,
  RailTitle,
  SortRow,
  SortSelect,
  Item,
  FieldName,
  Bar,
  BarFill,
  Foot,
  FootText,
  FootCount
} from './FieldRail.styles';

const footText = field => {
  if (!field.open_survey) return 'No open survey';
  const coverage = coverageOf(field);
  return coverage == null ? (
    'No coverage measured yet'
  ) : (
    <>
      <b>{Math.round(coverage * 100)} %</b> imaged this survey
    </>
  );
};

export const FieldRail = ({ fields, selectedId, onSelect, sortKey, onChangeSort }) => (
  <Rail>
    <RailTitle>Fields ({fields.length})</RailTitle>
    <SortRow>
      <label htmlFor='fields-sort'>Sort by</label>
      <SortSelect
        id='fields-sort'
        value={sortKey}
        onChange={event => onChangeSort(event.target.value)}
      >
        <option value={SORT_NAME}>Name</option>
        <option value={SORT_DENSITY}>Stones per acre</option>
      </SortSelect>
    </SortRow>
    {fields.map(field => (
      <Item
        key={field.id}
        type='button'
        aria-pressed={field.id === selectedId}
        onClick={() => onSelect(field.id)}
      >
        <FieldName>{field.name}</FieldName>
        <Bar>
          <BarFill style={{ width: `${(coverageOf(field) ?? 0) * 100}%` }} />
        </Bar>
        <Foot>
          <FootText>{footText(field)}</FootText>
          {field.open_survey && (
            <FootCount>
              <b>{formatCount(field.open_survey.stone_count)}</b> stones
            </FootCount>
          )}
        </Foot>
      </Item>
    ))}
  </Rail>
);
